import getBasePath from '../../functions/api-resource';

const basePath = getBasePath('api', 'configuracao-cadastro');

const configuracaoCadastroActions = {
  atualizar: { method: 'PUT', url: `${basePath}` },
  pesquisar: { method: 'GET', url: `${basePath}` },
};

export default resource => resource(`${basePath}`, {}, configuracaoCadastroActions);



// WEBPACK FOOTER //
// ./src/common/resources/configuracao/configuracao-cadastro.js